import { useState } from 'react'
import Styles from './useAutopilotUpgradeBanner.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Close, Lightning } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { AutopilotUpgradeModal } from 'components/AutopilotUpgradeModal/AutopilotUpgradeModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

const DISMISSAL_KEY = 'autopilot-upgrade-banner-dismissed'

export const useAutopilotUpgradeBanner = () => {
  const { openModal } = useModals()
  const { isMobile, isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()
  const workspace = useCurrentWorkspace()
  const [localDismissed, setLocalDismissed] = useState(false)

  const dismissed = localDismissed || !!localStorage.getItem(DISMISSAL_KEY)
  const showBanner = workspace && !workspace?.is_virtual_marketer && !isIOSNative && !isAPMobileWeb && !dismissed
  const openAutopilotUpgradeModal = () => {
    openModal(
      AutopilotUpgradeModal,
      {},
      {
        underlayVariant: isMobile ? 'mobileAutopilotUpgrade' : 'autopilotUpgrade',
      },
    )
  }

  const handlePress = () => {
    openAutopilotUpgradeModal()
  }

  const message = isMobile
    ? 'Introducing Blaze Autopilot. Try free for 7 days.'
    : 'Introducing Blaze Autopilot. Try free in a new workspace for 7 days.'

  const autopilotUpgradeBanner = (
    <div className={Styles.container}>
      <Lightning color="var(--light-100)" />
      <div className={Styles.message}>
        <Text variant="secondary" color="var(--light-100)">
          {message}
        </Text>
      </div>
      <div className={Styles.buttonContainer}>
        <Button size={isMobile ? 'sm' : 'xs'} onPress={handlePress} variant="secondary">
          Try Autopilot
        </Button>
      </div>
      <div className={Styles.close}>
        <Button
          aria-label="Dismiss Banner"
          onPress={() => {
            localStorage.setItem(DISMISSAL_KEY, 'true')
            setLocalDismissed(true)
          }}
          variant="tertiary"
          size="xs"
        >
          <Close size={16} color="var(--light-100)" />
        </Button>
      </div>
    </div>
  )

  return {
    showBanner,
    autopilotUpgradeBanner,
  }
}
